import { Box, Chip, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";

/**
 * Read-only rendering of a post exactly as it will look once published.
 * Shared by the author's editor ("Preview") and by admin moderation, where the
 * cover image and body had to be reviewable before publishing (QA 2026-07-27).
 */
const PostPreview = ({ open, onClose, post = {}, actions = null }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogContent>
      {post.coverImage && (
        <img
          src={post.coverImage}
          alt={post.title || "cover"}
          style={{ width: "100%", borderRadius: 8, marginBottom: 16, objectFit: "contain" }}
        />
      )}
      {post.category && <Chip label={post.category} size="small" sx={{ mb: 1 }} />}
      <Typography variant="h4" sx={{ mb: 1 }}>{post.title || "Untitled"}</Typography>
      {post.excerpt && (
        <Typography
          component="blockquote"
          sx={{ borderLeft: "3px solid #ccc", pl: 2, my: 2, fontStyle: "italic", color: "#555" }}
        >
          {post.excerpt}
        </Typography>
      )}
      {(post.tags || []).length > 0 && (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mb: 2 }}>
          {post.tags.map((t) => <Chip key={t} size="small" label={t} />)}
        </Box>
      )}
      {/* Body HTML is sanitized server-side on every save/publish. */}
      <Box className="ql-editor" sx={{ p: 0 }} dangerouslySetInnerHTML={{ __html: post.body || "" }} />
    </DialogContent>
    {actions && <DialogActions sx={{ px: 3, pb: 2 }}>{actions}</DialogActions>}
  </Dialog>
);

export default PostPreview;
